export default "__VITE_ASSET__9DIIwOO3__"